/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice\src\Utils\UrlParams.ts
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice
 * Created Date: Wednesday June 21st 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Friday, 30th June 2023 12:30:31
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

export function GetCurrentCarPage() {
  const searchPage = new URLSearchParams(window.location.search);
  const myPage = searchPage.get("page");
  return myPage === null ? 0 : parseInt(myPage) - 1;
}

export function GetCurrentNbPage(rowPerPageOptions?: number[]) {
  const searchPage = new URLSearchParams(window.location.search);
  const perPage = searchPage.get("per_page");
  return perPage === null ? (rowPerPageOptions ? rowPerPageOptions[0] : 20) : parseInt(perPage);
}

export function GetFilters(searchParams: string) {
  const searchFilters = new URLSearchParams(searchParams);
  const myFiltersSelected = searchFilters.get("filters");
  return myFiltersSelected === null || myFiltersSelected.length === 0
    ? []
    : myFiltersSelected.split(",");
}

export function GetOrderBy() {
  const searchOrderBy = new URLSearchParams(window.location.search);
  const orderBy = searchOrderBy.get("orderedby");
  let orderBySelected: string[] = [];
  if (orderBy !== null) orderBySelected = orderBy.split(",");
  return orderBy === null
    ? { name: "", order: "" }
    : { name: orderBySelected[0], order: orderBySelected[1] };
}

export function SearchParamsEquality(
  searchParams1: URLSearchParams,
  searchParams2: URLSearchParams
) {
  return searchParams1.toString() === searchParams2.toString();
}

export function IsThisFilterTrue(minVal: number, filters: string[]) {
  return minVal <= filters.length;
}

export function SetURLParams(param: string, value: string | number | boolean) {
  const url = window.location;
  const searchParams = new URLSearchParams(url.search);
  searchParams.set(param, value.toString());
  window.history.replaceState(null, "", `${url.pathname}?${searchParams.toString()}`);
}
